import {
  MERCHANT_PAYMENT_STATUS_REQUEST,
  MERCHANT_PAYMENT_STATUS_SUCCESS,
  MERCHANT_PAYMENT_STATUS_FAILURE,
} from "../actions/merchantAction";

const initialState = {
  merchant_payment_status_loading: false,
  merchant_payment_status_data: null,
  merchant_payment_status_error: null,
};

const merchantReducer = (state = initialState, action) => {
  switch (action.type) {
    case MERCHANT_PAYMENT_STATUS_REQUEST:
      return { ...state, merchant_payment_status_loading: true, merchant_payment_status_error: null };
    case MERCHANT_PAYMENT_STATUS_SUCCESS:
      return { ...state, merchant_payment_status_loading: false, merchant_payment_status_data: action.payload };
    case MERCHANT_PAYMENT_STATUS_FAILURE:
      return { ...state, merchant_payment_status_loading: false, merchant_payment_status_error: action.payload };
    default:
      return state;
  }
};

export default merchantReducer;
